export default {
  user: {},
  pushToken: '',
  isLoggedIn: false
};